import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

/** action cố định theo yêu cầu nghiệp vụ — chỉ tra cứu thời gian ONLINE. */
const ACTION = 'ONLINE';

export default class UserTimerLogPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            liveRoomUid: '',
            startTime: '',   // giá trị của input datetime-local: "yyyy-MM-ddThh:mm"
            endTime: '',
            result: null,
            loading: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.query = this.query.bind(this);
        this.reset = this.reset.bind(this);
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    /** datetime-local ("2026-06-01T19:30") -> định dạng backend ("2026-06-01 19:30:00"). */
    toBackendTime(value) {
        if (!value) return '';
        const [datePart, timePart = '00:00'] = value.split('T');
        const time = timePart.length === 5 ? timePart + ':00' : timePart;
        return `${datePart} ${time}`;
    }

    /** Làm tròn 1 chữ số thập phân, hiển thị an toàn khi thiếu dữ liệu. */
    formatMinutes(value) {
        if (value == null || isNaN(value)) return '--';
        return Number(value).toFixed(1);
    }

    /** Đổi phút -> "x giờ y phút" cho dễ đọc. */
    toHourMinute(value) {
        if (value == null || isNaN(value)) return '';
        const totalMinutes = Math.round(Number(value));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        if (hours === 0) return `${minutes} phút`;
        return `${hours} giờ ${minutes} phút`;
    }

    reset() {
        this.setState({
            liveRoomUid: '',
            startTime: '',
            endTime: '',
            result: null,
        });
    }

    query() {
        const { liveRoomUid, startTime, endTime } = this.state;

        // Backend nhận liveRoomUid kiểu số, gửi chuỗi sẽ lỗi parse.
        if (!/^\d+$/.test(liveRoomUid.toString().trim())) {
            toast.warning('ID phòng phải là số.');
            return;
        }
        if (!startTime || !endTime) {
            toast.warning('Vui lòng chọn đủ thời gian bắt đầu và kết thúc.');
            return;
        }
        if (startTime >= endTime) {
            toast.warning('Thời gian bắt đầu phải trước thời gian kết thúc.');
            return;
        }

        const requestData = {
            liveRoomUid: Number(liveRoomUid),
            action: ACTION,
            startTime: this.toBackendTime(startTime),
            endTime: this.toBackendTime(endTime),
        };

        this.setState({ loading: true });

        axios.post(
            global.config.apiDomain + '/mc-live-room/web/user-timer-log/summary',
            JSON.stringify(requestData),
            { headers: { 'Content-Type': 'application/json' } }
        ).then(res => {
            if (res.data.status === 'OK') {
                this.setState({ result: res.data.data, loading: false });
                toast.success('Tra cứu thành công!');
            } else {
                this.setState({ result: null, loading: false });
                toast.error('Tra cứu thất bại: ' + res.data.message);
            }
        }).catch(error => {
            console.error('Error querying user timer log:', error);
            this.setState({ loading: false });
            toast.error('Có lỗi xảy ra khi tra cứu!');
        });
    }

    renderResult() {
        const { result } = this.state;
        if (result == null) return null;

        const total = result.totalTotalTimer;
        const valid = result.totalValidTimer;
        // Tỷ lệ hợp lệ giúp đánh giá nhanh chất lượng thời gian online.
        const ratio = (total && !isNaN(total) && Number(total) > 0)
            ? (Number(valid) / Number(total) * 100).toFixed(1)
            : null;

        return (
            <>
                <hr />
                <h4>Kết quả tra cứu</h4>

                <div className="row">
                    <div className="col-md-4">
                        <div className="card text-center" style={{ padding: '20px', marginBottom: '15px' }}>
                            <div className="text-muted">Thời gian online</div>
                            <div style={{ fontSize: '2rem', fontWeight: 600 }}>
                                {this.formatMinutes(total)} <small>phút</small>
                            </div>
                            <div className="text-muted">{this.toHourMinute(total)}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card text-center" style={{ padding: '20px', marginBottom: '15px' }}>
                            <div className="text-muted">Online hợp lệ</div>
                            <div className="text-success" style={{ fontSize: '2rem', fontWeight: 600 }}>
                                {this.formatMinutes(valid)} <small>phút</small>
                            </div>
                            <div className="text-muted">{this.toHourMinute(valid)}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card text-center" style={{ padding: '20px', marginBottom: '15px' }}>
                            <div className="text-muted">Tỷ lệ hợp lệ</div>
                            <div style={{ fontSize: '2rem', fontWeight: 600 }}>
                                {ratio == null ? '--' : ratio + '%'}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    render() {
        const { liveRoomUid, startTime, endTime, loading } = this.state;

        return (
            <>
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Kiểm tra thời gian online hợp lệ</h1>
                        <hr />

                        <div className="row">
                            <div className="col-md-3 form-group">
                                <label>ID phòng sự kiện</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="liveRoomUid"
                                    value={liveRoomUid}
                                    onChange={this.handleChange}
                                    placeholder="VD: 6483771474182144"
                                />
                            </div>
                            <div className="col-md-3 form-group">
                                <label>Hành động</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={ACTION}
                                    disabled
                                />
                            </div>
                            <div className="col-md-3 form-group">
                                <label>Thời gian bắt đầu</label>
                                <input
                                    type="datetime-local"
                                    step="1"
                                    className="form-control"
                                    name="startTime"
                                    value={startTime}
                                    onChange={this.handleChange}
                                />
                            </div>
                            <div className="col-md-3 form-group">
                                <label>Thời gian kết thúc</label>
                                <input
                                    type="datetime-local"
                                    step="1"
                                    className="form-control"
                                    name="endTime"
                                    value={endTime}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <button
                                className="btn btn-primary mr-2"
                                onClick={this.query}
                                disabled={loading}
                            >
                                {loading ? 'Đang tra cứu...' : 'Tra cứu'}
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={this.reset}
                                disabled={loading}
                            >
                                Nhập lại
                            </button>
                        </div>

                        {this.renderResult()}
                    </div>
                </div>
            </>
        );
    }
}
